<template>
  <rui-drawer v-if="patch"
              :overlay="false"
              @close="$emit('close')">
    <template #caption>
      <!-- eslint-disable vue/no-v-html -->
      {{ patch.displayName }} <small v-if="measure" v-html="measure" />
      <!-- eslint-enable vue/no-v-html -->
    </template>
    <template #actions>
      <rui-button icon="notebook"
                  block
                  :disabled="patch.observationsCount === 0"
                  @click="showObservations(patch)">
        {{ $t('js.generic.observations') }} <small v-if="patch.observationsCount > 0">({{ patch.observationsCount }})</small>
      </rui-button>
    </template>

    <aside class="-pls -prd">
      <!-- Other geometries with multiple elements -->
      <rui-empty v-if="elements && elements.length === 0" icon-size="3" :content="$t('js.patch.no_element_in_this_patch')" small />
      <div v-else>
        <rui-list-item v-for="element in elements"
                       :key="element.id"
                       :caption="element.displayName"
                       :image="element.resource.picturePath"
                       static>
          <template #subCaption>
            <element-content :element="element" />
          </template>
          <template v-if="element.observationsCount > 0" #right>
            <rui-button icon="notebook" :caption="element.observationsCount" @click="showObservations(element)" />
          </template>
        </rui-list-item>
      </div>
    </aside>
  </rui-drawer>
</template>

<script>
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiEmpty from '@experiments-labs/rise_ui/src/components/DataDisplay/Empty/Empty.vue'
import RuiDrawer from '@experiments-labs/rise_ui/src/components/Drawer/Drawer.vue'
import RuiListItem from '@experiments-labs/rise_ui/src/components/ListItem/ListItem.vue'

import Patch from '../../../classes/models/Patch'

import { formatGeometryMeasure } from '../../../tools/MeasureFormatters'

import ElementContent from './_ElementContent.vue'

export default {
  name: 'PatchInfoDrawer',
  emits: [
    'close',
  ],
  components: { RuiListItem, RuiEmpty, RuiButton, RuiDrawer, ElementContent },
  props: {
    patch: { required: false, type: Patch, default: null },
  },
  computed: {
    elements () {
      return this.$store.getters.elementsByPatchId(this.patch.id)
        .filter(c => !c.isRemoved)
    },
    measure () { return formatGeometryMeasure(this.patch) },
  },
  methods: {
    showObservations (entity) {
      this.$emitBus('show-observations', entity)
    },
  },
}
</script>
